
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports
import {
    deletePlatform, getPlatformGridData
} from "./PlatformClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changePlatform} from "./platformSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import PlatformDrawer from "./PlatformDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import Button from "@mui/material/Button";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {ProfileGridColumns} from "../Profile/ProfileGridColumns";
import {PlatformGridColumns} from "./PlatformGridColumns";
import PlatformInfoDialogue from "./Info/PlatformInfoDialogue";
import {getAllDataPointValues} from "../../DataPointValue/DataPointValueClient";
import {changeDataPointAttribute} from "../../DataPointAttribute/dataPointAttributeSlice";


// main function
export default function PlatformGrid() {

    // ****************** BEGIN STATES ****************************

    const [platforms, setPlatforms] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [platformInfoOpen, setPlatformInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorPlatformId = useSelector((state) => state.platformSlc.value.id);
    const selectorPlatformMcode = useSelector((state) => state.platformSlc.value.mcode);
    const selectorPlatformName = useSelector((state) => state.platformSlc.value.name);
    const selectorPlatformDescription = useSelector((state) => state.platformSlc.value.description);
    const selectorPlatformCategory = useSelector((state) => state.platformSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.platformSlc.value.platformDrawerState);
    const selectorPlatformGridRefresh = useSelector((state) => state.platformSlc.value.platformGridRefresh);

    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectedId = useSelector((state) => state.platformSlc.value.id);

    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchPlatforms = React.useCallback( () => {
        getPlatformGridData()

            .then(data => {
                console.log(data);
                setPlatforms(data);
            });
},[]);

    useEffect(() => {
        fetchPlatforms();
    }, [fetchPlatforms]);

    //
    // useEffect(() => {
    //     fetchPlatforms();
    //     dispatchData(changePlatform({platformGridRefresh: false}));
    // }, [useSelector((state) => state.platformSlc.value.platformGridRefresh)===true]);


    useEffect(() => {
        if (!selectorPlatformGridRefresh) return;

        fetchPlatforms().finally(() => {
            dispatchData(changePlatform({
                platformGridRefresh: false
            }));
        });
    }, [selectorPlatformGridRefresh, fetchPlatforms, dispatchData]);



    // ****************** END FETCH ****************************

    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Platform"}));
    };

    const renderPlatforms = platforms => {
        if (platforms.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changePlatform({id: null, externalId: null, mcode: null, name: null,
            service: null, territory: null, usageMarket: null, owner: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            platformDrawerState: true, platformDrawerMode: "Add"}));
    };



    const removePlatform = () => {
        deletePlatform(selectorPlatformId).then(() => {
            setDeleteOpen(false);
            dispatchData(changePlatform({platformGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }
    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };


    function DeleteConfirmationDialog() {

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            deletePlatform(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changePlatform({platformGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // ****************** END CRUD ***********************************


    // ****************** BEGIN DRILLDOWN ****************************


    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (platforms) => {

        console.log('Platform data from clicked row');
        console.log(platforms);
        dispatchData(changePlatform({id: platforms.id, externalId: platforms.externalId,
            mcode: platforms.mcode, name: platforms.name,
            service: platforms.service, territory: platforms.territory,
            usageMarket: platforms.usageMarket, owner: platforms.owner,
            createdOn: platforms.createdOn,createdBy:platforms.createdBy,
            lastModifiedOn:platforms.lastModifiedOn,lastModifiedBy:platforms.lastModifiedBy}));
    };

    const handlePlatformInfo = () => {
        setPlatformInfoOpen(true);
    };

    const handleClosePlatformInfo = () => {
        setPlatformInfoOpen(false);
    };

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3 style={{cursor:'pointer'}}   onClick={() => handlePlatformInfo()}
                    >Platforms</h3>
                    </Tooltip>
                        <PlatformInfoDialogue
                            open={platformInfoOpen}
                            onClose={handleClosePlatformInfo}
                        />
                    <Button sx={{pt: 1, ml: 5}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <PlatformDrawer
            />}
            {/*}*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Platforms"}
                rows={platforms}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={PlatformGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changePlatform({ platformDrawerState: true, platformDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changePlatform({ platformDrawerState: true, platformDrawerMode: "Clone" })),
                    onDelete: removePlatform
                })}
                onRowClick = {(platforms)=>handleClickedRow(platforms.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={platform => platform.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}




